import { Component, AfterViewInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { EntryConfigInterface, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('form-send-outline-of-coverage-review')
@Component({
    selector: 'app-send-outline-of-coverage-review',
    templateUrl: './send-outline-of-coverage-review.component.html',
    styleUrls: ['./send-outline-of-coverage-review.component.scss'],
    standalone: false
})
export class SendOutlineOfCoverageReviewComponent extends FormEntryComponentClass {

  subEntry: EntryConfigInterface = {} as EntryConfigInterface;
  sendEmailEntry: EntryConfigInterface = {} as EntryConfigInterface;

  constructor() {
    super();
  }

  ngOnInit() {
    // Need to manually check control value to show/hide this component
    let controlValue = this.reducerUtilityService.getStateFromPath(this.reducerUtilityService.getPayloadStates(), this.entry.custom.controlPath);
    if (controlValue !== this.entry.custom.controlShowValue) {
      this.entry.base.display = false;
      return;
    }

    // copy the current control configs to pass to a new checkbox entry
    this.subEntry.formControlAttributes = this.entry.formControlAttributes;
    this.subEntry.checkboxAttributes = this.entry.checkboxAttributes;
    this.subEntry.base = this.entry.custom.subEntryBase;

    // Pull in the extra custom entry to rebuild the send email component correctly as another entry (no validations/listeners)
    this.sendEmailEntry = this.entry.custom.originalEntryAttributesForReview;
    // this custom value will drive the UI messages for the send email sub component
    this.sendEmailEntry.custom.isAppSubmitted = this.reviewOnly;

    // Add the checkbox form control
    this.form.addControl(this.entry.formControlAttributes.formControlName, new FormControl(null, Validators.required));
  }

  ngAfterViewInit() { }
}
